import {
  fetch,
  post
} from './http'

// 首页轮播图
export const indexImages = payload =>
  fetch('/apitest/Create', payload)
export const indexDegree = payload =>
  fetch('/apitest/DeList', payload)
export const indexShouye = payload =>
  fetch('/apitest/Shouye', payload)
export const degreeItem = payload =>
  fetch('/apitest/DeLists', payload)
export const submitInfo = payload =>
  fetch('/blog/addd', payload) 
export const indexDegreed = payload =>
  fetch('/apitest/DeListd', payload)
export const wxshare = payload =>
  fetch('/apitest/signature_api', payload)
export default {
  indexImages,
  indexDegree,
  indexShouye,
  degreeItem,
  submitInfo,
  indexDegreed,
  wxshare,
}